import(/* webpackMode: "eager" */ "/codebuild/output/src3281334794/src/apps/apps/blender/app/layout.tsx");
